import React, { useEffect, useRef } from "react";
import { Link, useMatch, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { mainPlayerToggle } from "../../redux/actions/styles";
import GradientPrimary from "../../components/gradient/GradientPrimary";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import NightlifeIcon from "@mui/icons-material/Nightlife";
import AlbumIcon from "@mui/icons-material/Album";
import SpatialAudioOffIcon from "@mui/icons-material/SpatialAudioOff";
import RadioIcon from "@mui/icons-material/Radio";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import RefreshIcon from "@mui/icons-material/Refresh";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import PodcastsIcon from "@mui/icons-material/Podcasts";
import FastForwardRoundedIcon from "@mui/icons-material/FastForwardRounded";

const Sidebar = () => {
  const scrollRef = useRef(null);
  const initialRenderRef = useRef(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const AC = bindActionCreators({ mainPlayerToggle }, dispatch);
  const { sidebarOpen } = useSelector((state) => state.styles);
  const { play, currentSong } = useSelector((state) => state.player);
  const { playlist } = useSelector((state) => state.music);

  useEffect(() => {
    if (location.pathname !== "/") {
      play && AC.mainPlayerToggle(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [play, currentSong]);

  useEffect(() => {
    if (initialRenderRef.current) {
      initialRenderRef.current = false;
    } else {
      scrollRef.current.scroll({ top: 5000, behavior: "smooth" });
    }
  }, [playlist]);

  return (
    <div className={`sidebar ${sidebarOpen ? "sidebar-open" : ""}`}>
      <GradientPrimary />
      <div className="logo">Logo</div>
      <div className="menu" ref={scrollRef}>
        <div className="section">
          <h3>Menu</h3>
          <Link to="/" className={`item ${useMatch("/") ? "item-active" : ""}`}>
            <MusicNoteIcon />
            <p>Explore</p>
          </Link>
          <Link to="/snap" className={`item ${useMatch("/snap") ? "item-active" : ""}`}>
            <FastForwardRoundedIcon />
            <p>Snap</p>
          </Link>
          <Link to="/genres" className={`item ${useMatch("/genres") ? "item-active" : ""}`}>
            <NightlifeIcon />
            <p>Genres</p>
          </Link>
          <Link to="/albums" className={`item ${useMatch("/albums") ? "item-active" : ""}`}>
            <AlbumIcon />
            <p>Albums</p>
          </Link>
          <Link to="/artists/artist" className={`item ${location.pathname.includes("/artists") ? "item-active" : ""}`}>
            <SpatialAudioOffIcon />
            <p>Artists</p>
          </Link>
          <Link to="/coming-soon" className="item">
            <RadioIcon />
            <p>Radio</p>
          </Link>
          <Link to="/coming-soon" className="item">
            <PodcastsIcon />
            <p>Podcasts</p>
          </Link>
        </div>
        <div className="section">
          <h3>Library</h3>

          <Link to="/coming-soon" className="item">
            <GraphicEqIcon />
            <p>Mashups</p>
          </Link>
          <Link to="/coming-soon" className="item">
            <FlashOnIcon />
            <p>Electronic</p>
          </Link>

          <Link to="/coming-soon" className="item">
            <LocationOnIcon />
            <p>Local Hits</p>
          </Link>
        </div>
        <div className="section">
          <h3>Playlists</h3>
          <Link
            to="/createplaylist"
            className={`item ${location.pathname.includes("/createplaylist") ? "item-active" : ""}`}
          >
            <PlaylistAddIcon />
            <p>Create New</p>
          </Link>
          <Link to="/coming-soon" className="item">
            <FavoriteIcon />
            <p>Favourites</p>
          </Link>
          {playlist.map((item) => (
            <Link
              key={item.ref}
              to={`playlist/${item.ref}`}
              className={`item ${location.pathname === `/playlist/${item.ref}` ? "item-active" : ""}`}
            >
              <PlaylistPlayIcon />
              <p>{item.name}</p>
            </Link>
          ))}

          <Link to="/coming-soon" className="item">
            <RefreshIcon />
            <p>Recent</p>
          </Link>
        </div>
      </div>
      <div className="device">Copyright © {new Date().getFullYear()} adityaprem all rights reserved.</div>
    </div>
  );
};

export default Sidebar;
